import Bag from './Bag';

export default Bag;
